export default "__VITE_ASSET__KA0$qr8n__"